export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <rect x="7" y="19.5" width="34" height="21" rx="3.5" stroke="#8B1E22" strokeWidth="2.6" />
    <path d="M24 19.5V40.5" stroke="#D4AF37" strokeWidth="2.6" />
    <rect x="4" y="12.5" width="40" height="7" rx="2" fill="#8B1E22" />
    <path d="M24 12.5C20.5 5.5 11.5 4 13 9.5c.8 3 6.5 3 11 3z" fill="#D4AF37" />
    <path d="M24 12.5C27.5 5.5 36.5 4 35 9.5c-.8 3-6.5 3-11 3z" fill="#E6C665" />
  </svg>
);

export default function Logo({ light = false }) {
  return (
    <span className="flex items-center gap-3" data-testid="brand-logo">
      <LogoMark className="h-10 w-10 shrink-0" />
      <span className="flex flex-col leading-none">
        <span
          className={`font-display text-[26px] font-semibold tracking-tight ${
            light ? "text-ivory" : "text-charcoal"
          }`}
        >
          A to Z
        </span>
        <span
          className={`font-mono text-[9px] uppercase tracking-[0.32em] mt-1 ${
            light ? "text-gold-light" : "text-terracotta"
          }`}
        >
          Gift &amp; Craft House
        </span>
      </span>
    </span>
  );
}
